import ValidService from "../service/ValidService";
let model = {};

// dữ liệu form
model.dataForm = {
  "id": undefined, // optional - Mã tự sinh
  "hien_thi": undefined, // required - Cho biết có hiển thị hay không
  "phan_loai": [], // required, array items: required, enum(app, web, ios, iphone, ipad, android) - Phân loại
  "thu_tu": undefined, // optional - Thứ tự hiển thị
  "tieu_de": undefined, // required - Tiêu đề
  "noi_dung": undefined, // required - Nội dung, định dạng MarkDown
  "tags": [], // optional - Danh sách các tag của câu hỏi
  "thoi_diem_tao": undefined, // required - Thời điểm tạo
  "thoi_diem_cap_nhat": undefined, // required - Thời điểm cập nhật cuối
  "nguoi_cap_nhat_id": undefined, // required, ref: mushroom_user - Người cập nhật cuối
};

// validation form
model.validForm = {
  tieu_de: [ValidService.required, ValidService.checkSpaceString],
  phan_loai: [ValidService.required, ValidService.requiredChange],
  noi_dung: [ValidService.required],
  hien_thi: [],
};

model.phanLoai = [
  {
    value: "app",
    label: "app",
  },
  {
    value: "web",
    label: "web",
  },
  {
    value: "ios",
    label: "ios",
  },
  {
    value: "iphone",
    label: "iphone",
  },
  {
    value: "ipad",
    label: "ipad",
  },
  {
    value: "android",
    label: "android",
  },
];

model.tableRules = {
  data: [],
  lengthMenu: [10, 20, 50, 100],
  allowPaging: true,
  allowSorting: true,
  allowSelect: false,
  showFormSearch: false,
  showUrl: true,
  total: 0,
  page: 1,
  limit: 10,
  offset: 0,
  sort: "-thoi-diem_tao",
  defaultSort: ["thoi_diem_tao", "descending"],
  filters: "",
  recordSelected: [],

  dataSearch: {
    value: {
      tieu_de: "",
      phan_loai: "",
      hien_thi: "",
      tags: "",
    },
    valid: {
      thoi_diem_tao: [],
      thu_tu: [],
      tieu_de: []
    },
    operator: {
      tieu_de: ":regex_i:",
      phan_loai: ":in:",
      hien_thi: "",
      tags: ":in:"
    },
  },
};

export default model;
